import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	Input,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { INotification } from 'domain/notification/notification';
import { AddCoacheeEvent } from 'presentation/app-sidebar/sidebar-add-coachee/events/add-coachee.event';
import { AddExistingCoacheeEvents } from 'presentation/app-sidebar/sidebar-add-existing-coachee/events/add-existing-coachee.events';
import { AppService } from 'presentation/app.service';

import { AppSidebarController } from './app-sidebar.controller';

@Component({
	selector: 'spr-app-sidebar',
	templateUrl: './app-sidebar.component.html',
	host: {
		class:
			'left-0 bottom-0 flex fixed items-stretch flex-col bg-white z-30 p-shadow',
	},
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppSidebarComponent {
	@Input() public showToggleButton: boolean;

	public showAddCoachee: boolean;

	constructor(
		private _el: ElementRef,
		public appService: AppService,
		private _cd: ChangeDetectorRef,
		public controller: AppSidebarController,
		private _translateService: TranslateService
	) {}

	public onCoacheeOpenPlan(userId: string) {
		this.controller.openUserPlan(userId);
	}

	public onCoacheeOpenChat(userId: string) {
		this.controller.openChatWithUser(userId);
	}

	public onCollapseClick() {
		this.controller.toggleSideBar();
	}

	public onUserPlanGoBack() {
		this.controller.cancelEditUserPlan();
	}

	public trackByNotification(
		index: number,
		notification: INotification
	): string {
		return notification.id;
	}

	public onAddCoacheeClose() {
		this.showAddCoachee = false;
		this._cd.markForCheck();
	}

	public onCreateCoacheeClick(data: AddCoacheeEvent) {
		this.controller.addCoachee(data).subscribe(() => this.onAddCoacheeClose());
	}

	public onCloseAllClick() {
		this.controller.closeAllNotifications();
	}

	public toggleNotifications() {
		this.controller.toggleNotifications();
	}

	public onAddExistingCoacheeClick(data: AddExistingCoacheeEvents) {
		this.controller.addExistingCoachee(data).subscribe(() => {
			this.onAddCoacheeClose();
		});
	}
}
